const CONFIG_FILENAME = 'config.json';

export { CONFIG_FILENAME };
//# sourceMappingURL=constants.js.map
